import { StyleSheet, css } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

export function SubmitNote({ note }: { note?: string }) {
	if (!note) {
		return null;
	}
	return (
		<span className={css(styles.note)} title={note}>
			<span className={css(styles.label)}>Rep’s note:</span> {note}
		</span>
	);
}

const styles = StyleSheet.create({
	label: {
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	note: {
		color: THEME.colors.text.main,
		// @ts-expect-error Aphrodite's display type has no -webkit-box, which line clamping needs
		display: '-webkit-box',
		fontSize: THEME.typography.fontSizes.xs,
		maxWidth: 280,
		overflow: 'hidden',
		overflowWrap: 'anywhere',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: 2,
		whiteSpace: 'normal',
	},
});
